const getMeta = (name) => {
  return document.querySelector(`meta[name="${name}"]`)?.content
}

export default getMeta
